import { BaseModel } from '../base/base-model.model';

export interface Classifier extends BaseModel {
    parentId: number;
    name: string;
    description: string;
    originalLuidaisId: number;
    tildeId: number;
    isActive: boolean;
    selected: boolean;
}

export enum ClassifierType {
    Groups = 1,
    GroupPermissions = 2,
    Permissions = 3,
    Sexes = 4,
    PersonTypes = 5,
    Vat = 6,
    InvoiceShowAccount = 7,
    ClientTypes = 8,
    PrintoutTypes = 9,
    EstimateStatusTypes = 10,
    AdvancePaymentTypes = 11,
    OwnershipTypes = 12,
    PaymentType = 13,
    PaymentStatus = 14,
    SContractType = 15,
    AbsenceStatus = 16,
    DocumentOwnership = 17,
    InvoiceType = 18,
    ExpenseStatusType = 19,
    UIThemeType = 20,
    HelpMaterialType = 21,
    FuelType = 24,
    FuelReportStatusType = 25,
    CardServiceType = 26,
    ScheduledJobType = 27,
    HrOrderStatusType = 31,
    Countries = 32,
    HrOrderAcknowledgementMode = 41,
}

export enum Permission {
    VIEW = 3001,
    NEW = 3002,
    EDIT = 3003,
}

// ids here are originalLuidaisId, because for now, originalLuidaisId is used as classifiers id!
export enum PersonTypes {
    Physical = 1,
    Legal = 2,
    Goverment = 3,
    Municipality = 4,
    Other = 5,
}

export enum ClientTypes {
    VIP = 1,
    CreditorRegular = 2,
    Regular = 3,
    CreditorGeneral = 4,
}

export enum PrintoutType {
    Estimate = 9001,
    Agreement = 9002,
    HrOrder = 9004,
}

export enum PaymentStatus {
    Initial = 14001,
    Settled = 14002,
    Failed = 14003,
}

export enum ExpenseRequestStatusType {
    NEW = 19001,
    SUBMITTER_SIGNING = 19002,
    WAITING_FOR_BOSS_APPROVAL = 19003,
    BOSS_SIGNING = 19004,
    WAITING_FOR_BOARD_APPROVAL = 19005,
    BOARD_SIGNING = 19006,
    APPROVED = 19007,
    DECLINED = 19008,
}

export enum FuelReportStatusType {
    NEW = 25001,
    SUBMITTER_SIGNING = 25002,
    WAITING_FOR_BOSS_APPROVAL = 25003,
    BOSS_SIGNING = 25004,
    WAITING_FOR_BOOKKEEPER_CHECK = 25005,
    APPROVED = 25006,
    DECLINED = 25007,
}

export enum UIThemeType {
    Default = 20001,
    DefaultCompact = 20002,
    Dark = 20003,
    DarkCompact = 20004,
    Aliyun = 20005,
    AliyunCompact = 20006,
    Colorful = 20007,
    ColorfulCompact = 20008,
    Mono = 20009,
    MonoCompact = 20010,
    Teams = 20011,
    TeamsCompact = 20012,
    TeamsAccented = 20013,
    TeamsAccentedCompact = 20014,
}

export enum HelpMaterialType {
    FILE = 21001,
    IMAGE = 21002,
    VIDEO = 21003,
    URL = 21004,
    YOUTUBE = 21005,
    SHAREPOINT_VIDEO = 21006,
}

export enum ScheduledJobType {
    DocumentSigningReminder = 27001,
    FuelReportApprovalReminder = 27002,
    ExpenseRequestApprovalReminder = 27003,
    AbsenceApprovalReminder = 27004,
    ExpenseReminder = 27005,
}

export enum AbsenceStatusType {
    REJECTED = 'REJECTED',
    NEW = 'NEW',
    APPROVED = 'APPROVED',
    FINISHED = 'FINISHED',
}

export enum Country {
    Latvia = 32001,
}
